const video: adUnit = {
  element: "video-placement",
  gamCode: "/21841313772,22653506037/wso/video",
  sizes: {
    mobile: [[300, 250]],
    tablet: [[1, 1]],
    desktop: [[1, 1]],
  },
  sizeMapping: [
    {
      viewPortSize: [1200, 250],
      sizes: [[1, 1], "fluid"],
    },
    {
      viewPortSize: [728, 250],
      sizes: [[1, 1], "fluid"],
    },
    {
      viewPortSize: [0, 0],
      sizes: [[300, 250], "fluid"],
    },
  ],
  vendors: {
    amazon: false,
    prebid: {
      enabled: true,
      mediaTypes: {
        banner: {
          sizeConfig: [
            { minViewPort: [0, 0], sizes: [[300, 250]] },
            { minViewPort: [728, 0], sizes: [] },
            { minViewPort: [1251, 0], sizes: [] },
          ],
        },
      },
      bids: [
        {
          bidder: 'equativ',
          params: {
            networkId: 5632,
          },
        },
        {
          bidder: "ix",
          params: {
            siteId: "957826",
          },
        },
        {
          bidder: "medianet",
          params: {
            cid: "8CUZX691M",
            crid: "873450629",
          },
        },
        {
          bidder: "nativo",
          params: {
            placementId: 1467952,
          },
        },
        {
          bidder: "oms",
          params: {
            publisherId: 20931,
          },
        },
        {
          bidder: "onetag",
          params: {
            pubId: "76b2c6676b744dc",
          },
        },
        {
          bidder: "pubmatic",
          params: {
            publisherId: "158347",
            adSlot: "4968130",
          },
        },
        {
          bidder: "rubicon",
          params: {
            accountId: "20438",
            siteId: "470922",
            zoneId: "2787326",
          },
        },
        {
          bidder: "sovrn",
          params: {
            tagid: "1116259", // 300x250
          },
          sizeConfig: [
            { minViewPort: [0, 0], relevantMediaTypes: ["banner"] },
            { minViewPort: [768, 0], relevantMediaTypes: ["none"] },
            { minViewPort: [1200, 0], relevantMediaTypes: ["none"] },
          ],
        },
        {
          bidder: "nobid",
          params: {
            siteId: 198057,
          },
        },
      ],
    },
  },
};

export default video;
